module.exports = __webpack_public_path__ + "static/media/wide.930a2bcb.jpg";